import React, { useState, useEffect, useRef } from 'react';
import '../../css/dropdownmenu.css';
import { useNavigate } from 'react-router-dom';
// import { useContext } from 'react';
// import { AuthContext } from '../../../context/AuthContext';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { fetchUserProfile } from '../../services/userService';
import { fetchFreelancerProfile, getFreelancerId } from '../../services/freelancerService';
import useProfileLinks from '../../hooks/useProfileLinks';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { getImage } from '../../utils/cloudinarySizing';
import SettingsModal from '../settings/SettingsModal';

const DropdownMenu = ({ isOpen, toggleDropdown, openSettings }) => {
    const dropdownRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showAccountDetails, setShowAccountDetails] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [freelancerId, setFreelancerId] = useState(null);
    const [freelancerName, setFreelancerName] = useState("Freelancer Profile");
    const [freelancerPic, setFreelancerPic] = useState("/servspace-default-40x40.png");

    const { accessToken, logout, setIsLoggingOut, role, profileThumbnail } = useAuth();
    const { profileBase } = useProfileLinks();
    const navigate = useNavigate();
    const profile = useSelector((state) => state.profile.data);
    const profileName =
        role === "freelancer"
            ? `${profile?.profile?.first_name || ""}${profile?.profile?.last_name ? ` ${profile.profile.last_name}` : ""}`.trim()
            : profile?.profile?.first_name ||
            profile?.user?.username ||
            profile?.profile?.email ||
            "Anonymous";

    const getFallbackImage = (role) => {
        if (role === "freelancer") return "/servspace-placeholder-500x500.png";
        if (role === "business") return "/servspace-business-placeholder-200.png";
        return "/servspace-default-40x40.png";
    };

    const isValidPhoto = (thumbnail) => {
        return (
            thumbnail &&
            thumbnail !== "null" &&
            thumbnail !== "undefined" &&
            !thumbnail.includes("null")
        );
    };

    const photoUrl = isValidPhoto(profileThumbnail)
        ? getImage(profileThumbnail, "avatar_xsm")
        : getFallbackImage(role);


    const goToModal = () => {
        toggleDropdown();
        openSettings();
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleGetFreelancerId = async () => {
        try {
            const data = await getFreelancerId();
            if (data.freelancer_id) {
                setFreelancerId(data.freelancer_id);
                fetchFreelancerData(data.freelancer_id);
            } else {
                console.error('Freelancer profile not found');
            }
        } catch (error) {
            console.error('Failed to get freelancer ID:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchFreelancerData = async (id) => {
        try {
            const response = await fetchFreelancerProfile(id);
            setFreelancerName(response.name);
            setFreelancerPic(response.image || "/servspace-default-40x40.png");
        } catch (error) {
            console.error('Error fetching freelancer data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLogout = () => {
        setIsLoggingOut(true);
        toggleDropdown();
        logout();
        setIsModalOpen(false);
    };

    const goToProfile = () => {
        toggleDropdown();
        setTimeout(() => {
            navigate(profileBase);
        }, 120);
    };

    const goToFreelancerProfile = async () => {
        if (freelancerId) {
            toggleDropdown();
            setTimeout(() => {
                navigate(`/home/freelancer/${freelancerId}`);
            }, 120);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (isOpen) toggleDropdown(); // Close only if open
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, toggleDropdown]);

    return (
        <>
            <div className="header-dropdown" ref={dropdownRef}>
                <div className="dropdown-trigger" onClick={toggleDropdown}>

                    <img
                        src={photoUrl}
                        alt="Profile"
                        className="profile-pic"
                        onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = getFallbackImage(role);
                        }}
                    />
                </div>
                {isOpen && (
                    <div
                        className="dropdown-menu"
                        style={{ backgroundColor: 'var(--secondary)', color: 'var(--text)' }}
                    >
                        <ul>
                            <li className="profile-option" style={{ fontSize: "16px" }} onClick={goToProfile}>
                                <img
                                    src={photoUrl}
                                    className="dropdown-profile-pic"
                                    alt="Profile"
                                    onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = getFallbackImage(role);
                                    }}
                                />
                                <div className="dropdown-profile-info">
                                    {role === "user" ? (
                                        <span style={{ fontWeight: "bold" }}>{profileName}</span>
                                    ) : role === "freelancer" ? (
                                        <>
                                            <span style={{ fontWeight: "bold" }}>
                                                {profile.profile?.first_name} {profile.profile?.last_name}
                                            </span>
                                            <p style={{ padding: 0, margin: 0 }}>@<span>{profile.user?.username}</span></p>
                                        </>
                                    ) : role === "business" ? (
                                        <>
                                            <span style={{ fontWeight: "bold" }}>{profile.business_profile?.business_name}</span>
                                            <p style={{ padding: 0, margin: 0 }}>@<span >{profile.user?.username}</span></p>
                                        </>
                                    ) : (
                                        <span style={{ fontWeight: "bold" }}>{profileName}</span>
                                    )}
                                </div>
                            </li>

                            <hr className="menu-separator" />

                            <li onClick={goToModal}>
                                <i className="fa-solid fa-gear"></i> Settings
                            </li>
                            <li onClick={handleLogout}>
                                Logout
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
};

export default DropdownMenu;
